import { getCookie, setCookie } from '../modules/cookie';

const trackConsent = () => {
  const submitted = !!getCookie('consentSubmitted');
  if (!submitted) setCookie('consentSubmitted', '1');

  const showBanner = !!getCookie('show_cookie_banner');

  document.body.dispatchEvent(new CustomEvent('jb-tracking', {
    detail: {
      event: submitted ? 'ce_update_consent' : 'ce_initial_consent',
      analytics: !!getCookie('allow_tracking_cookies'),
      marketing: !!getCookie('allow_marketing_cookies'),
    }
  }));
};

document.addEventListener('jb-cookie-settings:update', trackConsent);
